import * as React from 'react';
import { useEffect } from 'react';

import { DescriptionPage_DifficultyLevel as DifficultyLevel } from '__generated__/graphql-types';
import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import CML from 'bundles/unified-description-page-common/components/shared/CML';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import { useStickyPanel } from 'bundles/unified-description-page-common/contexts/StickyPanelContext';

import _t from 'i18n!nls/xdp';

type Props = ModalProps & {
  difficulty?: DifficultyLevel | null;
  cmlRecommendedBackground?: CmlContent | null;
};

const RecommendedExperienceModal = ({ difficulty, cmlRecommendedBackground, ...rest }: Props) => {
  const { updateHasOpenModal } = useStickyPanel();

  if (!difficulty || !cmlRecommendedBackground) return null;

  const { open } = rest;

  // FIXME: React Hook "useEffect" is called conditionally
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (updateHasOpenModal) {
      updateHasOpenModal(open);
    }
  }, [updateHasOpenModal, open]);

  const difficultyMap = {
    [DifficultyLevel.Beginner]: _t('Beginner level'),
    [DifficultyLevel.Intermediate]: _t('Intermediate level'),
    [DifficultyLevel.Advanced]: _t('Advanced level'),
  };

  return (
    <Modal {...rest} header={_t('Recommended experience')} supportText={difficultyMap[difficulty]}>
      <CML cml={cmlRecommendedBackground} />
    </Modal>
  );
};

export default RecommendedExperienceModal;
